import { EnumFeatureFlagName } from '@blank/api'
import { SignupDomiciliationContainer } from 'modules/auth/components/SignupDomiciliationContainer/SignupDomiciliationContainer'
import { Seo } from 'modules/common/components/Seo/Seo'
import { COUNTRY_API_BASE_URL_MAP } from 'modules/common/http/apiClient'
import { LayoutCentered } from 'modules/common/components/_layouts/LayoutCentered'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { fetchFeatureFlag } from 'modules/corporate/api/fetchFeatureFlag'
import { EnumUserLocale, USER_COUNTRY_MAP } from 'modules/common/types/locale'
import { BlankPage } from 'modules/common/types/page'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

interface SignupDomiciliationPageProps {
  isOnboardingClosed: boolean
}

export const SignupDomiciliationPage: BlankPage<
  SignupDomiciliationPageProps
> = ({ isOnboardingClosed }) => {
  const { t } = useTranslation('auth-page-signup-domiciliation')
  return (
    <>
      <Seo title={t('meta.title')} noindex={isOnboardingClosed} />
      <SignupDomiciliationContainer />
    </>
  )
}

export const getStaticProps: GetStaticProps<
  SignupDomiciliationPageProps
> = async ({ locale, locales }) => {
  const country = USER_COUNTRY_MAP[locale as EnumUserLocale]
  const baseURL = COUNTRY_API_BASE_URL_MAP[country]

  let isOnboardingClosed = false
  try {
    const data = await fetchFeatureFlag({
      featureName: EnumFeatureFlagName.CLOSE_ONBOARDING,
      baseURL,
    })
    isOnboardingClosed = data?.body?.enabled === true
  } catch {
    // API failure → default to indexable (safe)
  }

  return {
    props: {
      locales,
      ...(await serverSideTranslations(locale as EnumUserLocale, [
        'auth-components',
        'auth-page-signup-domiciliation',
        'common',
        'common-components',
      ])),
      isOnboardingClosed,
    },
    revalidate: 3600,
  }
}

SignupDomiciliationPage.type = 'notAuthenticated'

SignupDomiciliationPage.getLayout = (page) => (
  <LayoutCentered withBetaVersionBanner>{page}</LayoutCentered>
)

export default SignupDomiciliationPage
